import { IAdditionalInformation } from "us.collection.debtor/Interfaces";
import { DEFAULT_DRAWER_STATE } from "us.collection.debtor/constants/AdditionalInformation";

export const initialState: IAdditionalInformation = {
  informationList: {
    isLoading: true,
    data: [],
  },
  infoMetaData: {
    statusOptions: [],
    infoOptions: [],
    isLoading: true,
  },
  drawerInfo: DEFAULT_DRAWER_STATE,
  isInformationSaving: false,
  bmdDataTypeValues: {}
};
